import '@fontsource-variable/dm-sans';
import './index.css';
import './lang';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import router from './router';
import { ThemeProvider } from './theme/ThemeProvider';

createRoot(document.getElementById('app')!).render(
  <StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </StrictMode>,
);
